





















































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { IAnswer, IGalaxy } from '../../../../api_interface'

@Component
export default class extends Vue {
  @Prop({ required: true })
  answer!: IAnswer

  @Prop({ required: true })
  galaxy!: IGalaxy

  get captainAnswer() {
    return this.galaxy.captain_answer!
  }

  get showFeatures() {
    return this.answer.in_interaction === 'yes' || this.captainAnswer.in_interaction === 'yes'
  }

  get sameAsCaptain() {
    return this.answer.galaxy_type === this.captainAnswer.galaxy_type &&
      this.answer.in_interaction === this.captainAnswer.in_interaction &&
      this.answer.ring === this.captainAnswer.ring &&
      this.answer.fan === this.captainAnswer.fan &&
      this.answer.tail === this.captainAnswer.tail &&
      this.answer.distorted === this.captainAnswer.distorted
  }

  featureHtml(f: boolean) {
    return f ? '&check;' : ''
  }

  get localizedComment() {
    const localePrefix = this.$i18n.locale === 'ja' ? '' : `_${this.$i18n.locale}`
    const comment: string | undefined = (this.captainAnswer as any)[`comment${localePrefix}`]
    return comment
  }
}
